import '../App.css';

export default function Footer() {
    return (
        <div className='footer'>
            <button onClick={() => window.scrollTo(0, 0)}>Back to Top</button>
            <p>Designed and created by Valle Web</p>
        </div>
    )

}
